export default {
  questions: [],
  question: undefined,
};
